import { Link } from "react-router-dom";
import { TreePine, Sparkles, Wrench, Droplets, Home as HomeIcon, Building2 } from "lucide-react";
import Seo from "@/components/Seo";

const SERVICES = [
  { icon: HomeIcon, title: "Residential Landscaping", text: "Full-scope design and installation for homes, villas, and apartments." },
  { icon: Building2, title: "Commercial Landscaping", text: "Hotels, offices, schools and hospitals — plantation + maintenance contracts." },
  { icon: TreePine, title: "Terrace & Balcony Gardens", text: "Container gardens, planter beds and irrigation for rooftops of any size." },
  { icon: Sparkles, title: "Vertical Gardens", text: "Custom green walls with drip irrigation for indoors and facades." },
  { icon: Droplets, title: "Lawns & Irrigation", text: "Grass installation, sprinkler and drip systems, annual maintenance." },
  { icon: Wrench, title: "Garden Maintenance", text: "Pruning, fertilization, pest control and plant health check-ups." },
];

export default function Services() {
  return (
    <div data-testid="services-page" className="mx-auto max-w-7xl px-4 py-10 md:py-14 pb-24">
      <Seo
        title="Landscaping & Plant Design Services"
        description="Residential and commercial landscaping, terrace and vertical gardens, lawns and irrigation, plus garden maintenance from YourPlants.in — book a free site visit or explore Design My Space."
        path="/services"
      />
      <div className="text-xs uppercase tracking-widest text-[var(--yp-muted)]">Landscaping & services</div>
      <h1 className="font-serif-display text-3xl md:text-5xl text-[var(--yp-primary)] max-w-3xl">Design, plant and maintain green spaces that grow with you.</h1>
      <p className="text-[var(--yp-muted)] mt-4 max-w-2xl">From boutique home terraces to corporate campuses, our horticulture team handles design, sourcing, plantation and long-term care.</p>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {SERVICES.map((s) => (
          <div key={s.title} className="card-hover bg-white border border-[var(--yp-border)] rounded-2xl p-6">
            <div className="w-11 h-11 rounded-full bg-[var(--yp-surface-alt)] text-[var(--yp-primary)] grid place-items-center"><s.icon size={20} /></div>
            <div className="font-serif-display text-xl text-[var(--yp-primary)] mt-4">{s.title}</div>
            <p className="text-sm text-[var(--yp-muted)] mt-2">{s.text}</p>
            <div className="mt-4 flex gap-3">
              <Link to="/site-visit" className="text-sm text-[var(--yp-primary)] font-medium hover:underline">Book visit</Link>
              <Link to="/bulk" className="text-sm text-[var(--yp-primary)] font-medium hover:underline">Get a quote</Link>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-14 bg-[var(--yp-primary)] text-white rounded-3xl p-8 md:p-12 text-center">
        <h2 className="font-serif-display text-3xl md:text-4xl">Ready to transform your space?</h2>
        <p className="opacity-85 mt-3">Free first consultation on all landscaping projects.</p>
        <div className="mt-6 flex justify-center gap-3 flex-wrap">
          <Link to="/site-visit" className="rounded-full bg-white text-[var(--yp-primary)] px-6 py-3 text-sm font-semibold hover:bg-[var(--yp-accent)] hover:text-[var(--yp-text)]">Book Site Visit</Link>
          <Link to="/bulk" className="rounded-full border border-white/40 text-white px-6 py-3 text-sm font-medium hover:bg-white/10">Request Bulk Quote</Link>
        </div>
      </div>
    </div>
  );
}
